<template>
  <div class="main dashboard-diario">
    <c-panel title="Monitoramento do Diário" titleIcon="fas fa-chart-pie">

      <el-form label-position="top" @submit.native.prevent>
          <el-row :gutter="10" class="filtros u-mb-10" v-if="ehNti">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="Instituição" key="instituicao">
                <el-select
                  v-model="instituicaoSelecionada"
                  filterable
                  clearable
                  placeholder="Todas as escolas (município)"
                  @change="onChangeInstituicao"
                  style="width: 100%"
                >
                  <el-option
                    v-for="inst in instituicoes"
                    :key="inst.id"
                    :label="inst.nome"
                    :value="inst.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="16">
              <div class="info-nti">
                <i class="fas fa-info-circle"></i>
                Sem instituição selecionada, os indicadores agregam todas as escolas do município.
              </div>
            </el-col>
          </el-row>
      </el-form>

      <el-tabs v-model="tabAtiva" class="tabs">
        <el-tab-pane label="Visão Geral" name="visao-geral">
          <visao-geral
            v-if="tabAtiva === 'visao-geral'"
            :periodo-id="periodoId"
            :instituicao-id="instituicaoEfetiva"
            :municipal="modoMunicipal"
          />
        </el-tab-pane>
        <el-tab-pane label="Frequência" name="frequencia">
          <frequencia-tab
            v-if="tabAtiva === 'frequencia'"
            :periodo-id="periodoId"
            :instituicao-id="instituicaoEfetiva"
            :municipal="modoMunicipal"
          />
        </el-tab-pane>
        <el-tab-pane label="Notas" name="notas">
          <notas-tab
            v-if="tabAtiva === 'notas'"
            :periodo-id="periodoId"
            :instituicao-id="instituicaoEfetiva"
            :municipal="modoMunicipal"
          />
        </el-tab-pane>
      </el-tabs>

    </c-panel>
  </div>
</template>

<script>
export default {
  name: 'DashboardDiario',
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    VisaoGeral: () => import('./tabs/VisaoGeral.vue'),
    FrequenciaTab: () => import('./tabs/Frequencia.vue'),
    NotasTab: () => import('./tabs/Notas.vue')
  },
  data: () => ({
    tabAtiva: 'visao-geral',
    instituicaoSelecionada: null,
    tiposNti: [4, 5]
  }),
  computed: {
    tipoUser () {
      return Number(this.$store.state.user.tipo)
    },
    ehNti () {
      return this.tiposNti.includes(this.tipoUser)
    },
    periodoId () {
      return this.$store.state.config.periodo && this.$store.state.config.periodo.id
    },
    instituicoes () {
      return this.$store.state.instituicoes || []
    },
    modoMunicipal () {
      return this.ehNti && !this.instituicaoSelecionada
    },
    instituicaoEfetiva () {
      if (this.ehNti) return this.instituicaoSelecionada || null
      return this.$store.state.config.instituicao && this.$store.state.config.instituicao.id
    }
  },
  methods: {
    onChangeInstituicao () {
      // O watch nos filhos já reage à mudança via prop
    }
  }
}
</script>

<style scoped>
.dashboard-diario .filtros {
  padding: 6px 0 0 0;
}
.info-nti {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  padding: 8px 0;
}
.info-nti i { color: #346daa; margin-right: 6px; }
.tabs { margin-top: 6px; }
</style>
